const EventEmitter = require('eventemitter3');

const StandardStrike = require('../StandardStrike');
const BattleCalc = require('../../BattleCalc');
const BattleConfig = require('../../../constants/BattleConfig');
const CCHandler = require('../../CCHandler');
const ArmorBrokenCondition = require('../../conditions/ArmorBrokenCondition');
const { logError } = require('../../logger');

const ArmorBreak = function(battleState) {
  this.handle = 'armor_break';
  this.physical = true;
  this.weapon = true;
  this.harm = true;

  this.standardStrike = new StandardStrike(this, battleState);

  this.eventEmitter = new EventEmitter();

  this.isLegal = function(actor, victim) {
    return victim && victim.unit;
  };

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
      return { success: false };
    }

    try {
      const ability = BattleCalc.getEquippedAbility(actor, this.handle);

      const result = this.standardStrike.execute(
        actor,
        victim,
        0,
        false,
      );
      result.actorId = actor.uid;
      result.victimId = victim.uid;

      if (result.success && !victim.dead) {
        var alreadyBroken = BattleCalc.getCondition(victim, 'armor_broken');
        if (alreadyBroken) {
          alreadyBroken.potency += ability.potency;
          battleState.updateCondition(victim.uid, alreadyBroken.uid);
          result.armorBrokenCondition = alreadyBroken;
        } else {
          var armorBroken = new ArmorBrokenCondition(actor, victim, battleState, ability.potency);
          armorBroken.instigatorId = actor.uid;
          armorBroken.ownerId = victim.uid;
          battleState.onUnitCondition(armorBroken);
          result.armorBrokenCondition = armorBroken;
        }
      }

      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim? victim.uid : null;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'ArmorBreak',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
};
module.exports = ArmorBreak;
